import styled from 'styled-components';

const FormItemStyle = styled.div`
	--inputBorderRadius: var(--sp1x);
	--inputPadding: var(--sp2x) var(--sp3x);
	--errorMessagePaddingLeft: var(--sp3x);
	--fItemMarginBottom: var(--sp5x);

	//! Error

	.ant-form-item {
		margin-bottom: var(--fItemMarginBottom);
	}

	.ant-input-suffix {
		display: none;
	}

	.ant-input-affix-wrapper {
		&.ant-input-affix-wrapper-status-error {
			.ant-input {
				&::placeholder {
					color: var(--errorColor);
				}
			}
		}

		&.ant-input-affix-wrapper-status-error {
			.ant-input {
				color: var(--errorColor);
				border: 1px solid var(--errorColor);
			}
		}
	}

	.ant-input {
		width: 100%;
		padding: var(--inputPadding);
		font-size: 16px;
		border-radius: var(--inputBorderRadius);
		border: 1px solid var(--secondaryColor4);
		outline: none;
		background-color: var(--primaryColor3);

		&::placeholder {
			color: var(--secondaryColor2);
			font-family: var(--ping);
			font-weight: 400;
			font-size: var(--pS);
		}

		&:focus {
			border: 1px solid var(--bgBlackPearl);
		}
	}

	.ant-form-item-has-error {
		textarea {
			&::placeholder {
				color: var(--errorColor);
			}
		}
	}

	.ant-form-item-has-error {
		input,
		textarea {
			border: 1px solid var(--errorColor);
			color: var(--errorColor) !important;

			&::placeholder {
				color: var(--errorColor) !important;
			}
		}
	}

	.ant-form-item-explain {
		color: var(--errorColor) !important;
		font-size: var(--pXS) !important;
		clear: both;
		padding-left: var(--errorMessagePaddingLeft);
		/* transform: translateY(var(--sp1x)); */
		transform: translateY(calc(var(--pXS) - 8px));
		transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

		//! absolute for changer scrub
		position: absolute;
		top: 100%;
	}

	.ant-form-item-with-help .ant-form-item-explain {
		height: auto;
		opacity: 1;
		text-align: left;
	}
	.ant-show-help {
		transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	}
	.ant-show-help-appear,
	.ant-show-help-enter {
		opacity: 0;
	}
	.ant-show-help-appear-active,
	.ant-show-help-enter-active {
		opacity: 1;
	}
	.ant-show-help-leave {
		opacity: 1;
	}
	.ant-show-help-leave-active {
		opacity: 0;
	}
	.ant-show-help-item {
		overflow: hidden;
		transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
	}
	.ant-show-help-item-appear,
	.ant-show-help-item-enter {
		transform: translateY(-8px);
		opacity: 0;
	}
	.ant-show-help-item-appear-active,
	.ant-show-help-item-enter-active {
		transform: translateY(0);
		opacity: 1;
	}
	.ant-show-help-item-leave {
		transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
	}
	.ant-show-help-item-leave-active {
		transform: translateY(-8px);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp4x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--inputPadding: var(--sp1-5x) var(--sp2x);
		--errorMessagePaddingLeft: var(--sp2x);
		--fItemMarginBottom: var(--sp3x);
	}
`;

export default FormItemStyle;
